import { render, staticRenderFns } from "./AppSiteFooter.vue?vue&type=template&id=67c6a634&scoped=true&"
import script from "./AppSiteFooter.vue?vue&type=script&lang=js&"
export * from "./AppSiteFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c6a634",
  null
  
)

export default component.exports